module.exports = __webpack_public_path__ + "img/Icon-order-arrow-up.e579a850.svg";